import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { TooltipAppendsTo, TooltipDirective, TooltipPlacement, TooltipSize } from './tooltip.directive';

/**
 * An AngularJS compatibility wrapper for the `capraTooltip` directive.
 */
@Component({
  standalone: true,
  selector: 'capra-compat-tooltip-wrapper',
  imports: [TooltipDirective],
  templateUrl: './tooltip-wrapper.component.html',
  styleUrls: ['./tooltip-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TooltipWrapperComponent {
  @Input() tooltipContent = '';
  @Input() tooltipContentIsHtml = false;
  @Input() tooltipSize: TooltipSize = 'regular';
  @Input() tooltipPlacement: TooltipPlacement = 'top';
  @Input() tooltipIsDisabled = false;
  @Input() tooltipDelay: number | [number, number] = 0; // either a number or an array with two numbers
  @Input() tooltipForceShow = false;
  @Input() tooltipOffset?: [number, number];
  @Input() tooltipAppendTo?: TooltipAppendsTo;
  @Input() tooltipInteractive = false;
}
